export default __webpack_public_path__ + "static/media/l1.c7e70aa1.jpg";